var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60145",
    "data-name": "Group 60145",
    transform: "translate(8895.893 -12371.107)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16336",
    "data-name": "Rectangle 16336",
    width: 100,
    height: 100,
    transform: "translate(-8895.893 12371.107)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_9cc18b0cbe765b0a28791d253207f0c0",
    "data-name": "9cc18b0cbe765b0a28791d253207f0c0",
    transform: "translate(-8895.893 12371.107)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1572",
    "data-name": "Ellipse 1572",
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#8247e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17230",
    "data-name": "Path 17230",
    d: "M228.229,247.2a4.23,4.23,0,0,0-4.076,0l-9.35,5.347-6.353,3.487-9.35,5.347a4.23,4.23,0,0,1-4.076,0l-7.432-4.184a3.99,3.99,0,0,1-2.038-3.371v-8.252a3.751,3.751,0,0,1,2.038-3.371l7.313-4.068a4.23,4.23,0,0,1,4.076,0l7.312,4.068a3.989,3.989,0,0,1,2.038,3.371v5.347l6.353-3.6v-5.347a3.751,3.751,0,0,0-2.038-3.371L199.1,230.923a4.23,4.23,0,0,0-4.076,0l-13.786,7.671a3.751,3.751,0,0,0-2.038,3.371v15.459a3.751,3.751,0,0,0,2.038,3.371l13.786,7.671a4.23,4.23,0,0,0,4.076,0l9.35-5.23,6.353-3.6,9.35-5.23a4.23,4.23,0,0,1,4.076,0l7.313,4.068a3.99,3.99,0,0,1,2.038,3.371v8.252a3.751,3.751,0,0,1-2.038,3.371l-7.313,4.184a4.23,4.23,0,0,1-4.076,0l-7.313-4.068a3.989,3.989,0,0,1-2.038-3.371v-5.347l-6.353,3.6v5.347a3.751,3.751,0,0,0,2.038,3.371l13.786,7.671a4.23,4.23,0,0,0,4.076,0l13.786-7.671a3.989,3.989,0,0,0,2.038-3.371V258.354a3.751,3.751,0,0,0-2.038-3.371Z",
    transform: "translate(-161.808 -208.011)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.0292fcda47dcdd66e7bb00452df62659.svg";
export { ForwardRef as ReactComponent };